{
  "marketing_list": {
    "info": {
      "update_aria_label": "Update list information",
      "list_suffix": "list, ",
      "contacts_total": "contacts in total, last updated at"
    },
    "form": {
      "name_required": "Please name your list",
      "category_required": "Please select a category",
      "list_name_label": "List Name *",
      "list_name_placeholder": "Name of the list",
      "create_header": "Create Marketing List",
      "update_header": "Update Marketing List"
    },
    "header": {
      "archived_label": "archived"
    },
    "actions": {
      "add_contact": "Add Contact",
      "missing_field": "Missing Field",
      "request_contacts": "Request Contacts"
    },
    "category": {
      "label": "Category",
      "any": "Any"
    },
    "contact_request": {
      "description": "Share this URL to request others to add their contacts to this list."
    },
    "categories": {
      "client_alert": "Client Alert",
      "country_group": "Country Group",
      "event_invite": "Event Invite",
      "general_marketing": "General Marketing",
      "newsletter": "Newsletter",
      "office_lists": "Office Lists",
      "other": "Other",
      "practice_area": "Practice Area",
      "sector_or_industry": "Sector Or Industry",
      "subscribers": "Subscribers",
      "webinar_invite": "Webinar Invite"
    }
  },
  "excluded_contacts": {
    "alert_message": "There are {{count}} contacts in this list with matching exclusion rules.",
    "show_excluded_link": "Show me the excluded contacts."
  },
  "filters": {
    "title": "Filter",
    "contact_status": {
      "label": "Contact Status",
      "all": "All",
      "bounced": "Bounced",
      "unengaged": "Unengaged",
      "marketing_excluded": "Marketing Excluded"
    },
    "consent_status": {
      "label": "Consent Status",
      "legitimate_interest_tooltip": "You may contact the individual without explicit consent due to existing relationship."
    },
    "tags": {
      "label": "Tags",
      "placeholder": "Type or select tags"
    },
    "added_by": {
      "label": "Added by",
      "placeholder": "Type name or email"
    },
    "missing_field": "Missing Field",
    "active_filters_aria": "{{count}} filters are active",
    "apply": "Apply",
    "clear_filters": "Clear Filters"
  }
}
